var basil = new window.Basil({
    namespace: "hr-branch-company",
    storages: ["local", "session", "cookie", "memory"],
    storage: "local",
});
var vm = new Vue({
    el: "#YI",
    data: {
        scene: "account",
        isCheckbox: false,
        account: "",
        password: "",
    },
    mounted: function () {
        var that = this;
        document.addEventListener("scroll", function () {
            //that.scrollTop = window.scrollY;
        });
        window.addEventListener("touchmove", function (event) {
            //that.scrollTop = window.scrollY;
        });
    },
    methods: {
        Login: function () {
            var that = this;
            Y.Axios.post(G.Api + "/web/login", {
                username: that.account,
                password: that.password,
            }).then(function (reply) {
                // layer.open({
                //     content: reply.msg,
                //     skin: "msg",
                //     time: 1 //2秒后自动关闭
                // });
                // type:'info',           //显示类型，包括4种：success.error,info,warning 默认info

                if (reply.code === 200) {
                    $.message({
                        message: reply.msg,
                        type: "success",
                        duration: 1500,
                    });
                    basil.set("loginData", reply.data);
                    setTimeout(function () {
                        location.href = "/company/index.html";
                    }, 1500);
                    Y.Local.set("token", reply.data.token);
                    Y.Local.set("comId", reply.data.comId);
                    Y.Local.set("userId", reply.data.userId);
                    Y.Local.set("userType", reply.data.userType);
                    Y.Local.set("userName", reply.data.userName);
                    // setTimeout(function () {
                    //     location.href = "/admin/index.html";
                    // }, 1500);
                } else {
                    $.message({
                        message: reply.msg,
                        type: "error",
                        duration: 1500,
                    });
                }
            });
        },
        forgotPass: function () {
            location.href = "forgot-pass.html";
        },
        // 切换到短信登录
        toggleSMS: function () {
            this.scene = "sms";
        },
        // 切换到登录
        toggleAccount: function () {
            this.scene = "account";
        },
        // 切换选择框
        toggleCheckbox: function () {
            this.isCheckbox = !this.isCheckbox;
        },
    },
});
